import { isSameTime, Time } from 'app/shared/models';

import { AppMode } from './app-mode';
import { AppSettings, defaultMasterDataCacheDurationInMs } from './app-settings';
import { InputMode } from './input-mode';

export interface AppSettingsFormInput {
    allowManualSelection: boolean;
    appMode: AppMode;
    identifier: string;
    inputMode: InputMode | null;
    scanFlowRegistrationSubmitIntervalSec: number;
    userSessionExpirationTime: Time;
}

export function areAppSettingsFormInputsEqual(
    a: Partial<AppSettingsFormInput>,
    b: Partial<AppSettingsFormInput>,
) {
    return (
        a.allowManualSelection === b.allowManualSelection &&
        a.appMode === b.appMode &&
        a.identifier === b.identifier &&
        a.inputMode === b.inputMode &&
        ((a.userSessionExpirationTime &&
            b.userSessionExpirationTime &&
            isSameTime(a.userSessionExpirationTime, b.userSessionExpirationTime)) ||
            a.userSessionExpirationTime === b.userSessionExpirationTime) &&
        a.scanFlowRegistrationSubmitIntervalSec === b.scanFlowRegistrationSubmitIntervalSec
    );
}

export function mapAppSettingsToFormInput({
    settings,
    identifier,
}: {
    settings: AppSettings;
    identifier: string;
}): AppSettingsFormInput {
    return {
        ...settings,
        identifier,
        inputMode: settings.inputModes.length ? settings.inputModes[0] : null,
        scanFlowRegistrationSubmitIntervalSec: Math.round(
            settings.scanFlowRegistrationSubmitIntervalMs / 1000,
        ),
    };
}

export function mapFormInputToAppSettings(formValues: AppSettingsFormInput): AppSettings {
    return {
        ...formValues,
        inputModes: formValues.inputMode ? [formValues.inputMode] : [],
        scanFlowRegistrationSubmitIntervalMs: formValues.scanFlowRegistrationSubmitIntervalSec * 1000,
        masterDataCacheDurationInMs: defaultMasterDataCacheDurationInMs,
    };
}
